import styled from 'styled-components'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { fadeInOnRender } from 'styles/animations'

export const StatementsWrapper = styled(Box)`
    ${fadeInOnRender};
`

export const StyledValidationMessage = styled(Text)`
    ${fadeInOnRender};
`
